// extracted by mini-css-extract-plugin
export var primary = "styles-module--primary--1q1RF";
export var secondary = "styles-module--secondary--2cvgx";